import { Injectable } from '@angular/core';
import { StringUtilsService } from './string-utils.service';

@Injectable({ providedIn: 'root' })
export class RenderUtilsService {
  constructor(private stringUtils: StringUtilsService) {}

  renderStringList(arr: any[], key = '', show?: number): string {
    try {
      const limited = show ? arr.slice(0, show) : arr;
      return this.stringUtils.arrayStringJoin(limited, key, ',', true);
    } catch {
      return '';
    }
  }

  checkInHasNewValue(hasValue: boolean): string {
    return hasValue ? 'border border-primary' : '';
  }
}
